import Container from './styled/Container'

const Canvas = Container
export default Canvas
